import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => {
  return {
    title: {
      fontSize: 16,
      fontWeight: 700,
      marginBottom: 10,
      marginTop: 40,
    },
    description: {
      color: theme.palette.text.secondary,
      fontWeight: 500,
      fontSize: 14,
    },
  }
})

export default function CategoryTitle({ data }) {
  const classes = useStyles()
  return (
    <div>
      <Typography className={classes.title} variant="body2">
        {data.title}
        {': '}
        <span color="textSecondary" className={classes.description}>{data?.description}</span>
      </Typography>
    </div>
  )
}
